<template>
    <a-button @click="openAdvancedFilter" type="primary" block>
        <i class="fa fa-filter me-2" /> Construtor de Consultas
    </a-button>

    <a-modal v-model:open="showAdvFilterDialog" width="70%" :footer="null" title="Construtor de Consultas e Estilos Espaciais">
        <div v-if="mapLayers.length > 0">
            <a-tabs v-model:activeKey="advFilterTab">
                <a-tab-pane key="1" tab="1. Origem dos Dados">
                    <a-form layout="vertical">
                        <a-form-item label="Modo de Consulta">
                            <a-radio-group v-model:value="advFilterState.mode">
                                <a-radio-button value="single">Camada Única</a-radio-button>
                                <a-radio-button value="join">Mesclar Duas Camadas (Join)</a-radio-button>
                            </a-radio-group>
                        </a-form-item>
                        <div v-if="advFilterState.mode === 'single'">
                            <a-form-item label="Selecione a Camada alvo da pesquisa:">
                                <a-select v-model:value="advFilterState.targetLayer" :options="mapLayersFilterOptions" style="width: 100%">
                                    <template #notFoundContent>
                                        <a-empty description="Nenhuma camada ativa disponível" />
                                    </template>
                                </a-select>
                            </a-form-item>
                        </div>
                        <div v-if="advFilterState.mode === 'join'" style="background: #f8f9fa; padding: 15px; border-radius: 8px;">
                            <a-row :gutter="16">
                                <a-col :span="12">
                                    <a-form-item label="Camada Principal (A):">
                                        <a-select @change="() => advFilterState.joinSecondaryLayer = null" v-model:value="advFilterState.joinMainLayer" :options="mapLayersFilterOptions" style="width: 100%">
                                            <template #notFoundContent>
                                                <a-empty description="Nenhuma camada disponível" />
                                            </template>
                                        </a-select>
                                    </a-form-item>
                                </a-col>

                                <a-col :span="12">
                                    <a-form-item label="Camada Secundária (B):">
                                        <a-select v-model:value="advFilterState.joinSecondaryLayer" :options="mapLayersFilterOptions.filter((opt) => opt.value !== advFilterState.joinMainLayer)" style="width: 100%">
                                            <template #notFoundContent>
                                                <a-empty description="Nenhuma camada disponível" />
                                            </template>
                                        </a-select>
                                    </a-form-item>
                                </a-col>
                            </a-row>
                            <a-form-item label="Tipo de Relação (Join):">
                                <a-select v-model:value="advFilterState.joinType" style="width: 100%">
                                    <a-select-option value="union">UNION: Juntar todas as geometrias de A e B.</a-select-option>
                                    <a-select-option value="inner">INNER JOIN: Manter áreas de A que tem relação com B.</a-select-option>
                                    <a-select-option value="left">LEFT JOIN: Manter A, herdando atributos de B onde houver relação.</a-select-option>
                                </a-select>
                            </a-form-item>
                            <a-form-item v-if="advFilterState.joinType !== 'union'" label="Como as camadas se relacionam?">
                                <a-radio-group v-model:value="advFilterState.joinMethod" style="margin-bottom: 10px;">
                                    <a-radio value="spatial">Interseção Espacial (Geometrias se tocam/Topologia)</a-radio>
                                    <a-radio value="attribute">Igualdade de Atributos (Tabela)</a-radio>
                                </a-radio-group>
                                <a-row v-if="advFilterState.joinMethod === 'attribute'" :gutter="16">
                                    <a-col :span="11">
                                        <a-select v-model:value="advFilterState.joinAttrMain" placeholder="Atributo Camada A" style="width: 100%">
                                            <a-select-opt-group v-if="joinMainLayerAttributes" :key="joinMainLayerAttributes.name">
                                                <template #label>
                                                    <span>{{ joinMainLayerAttributes.name }}</span>
                                                </template>
                                                <a-select-option v-for="field in joinMainLayerAttributes.fields" :key="`${joinMainLayerAttributes.table}.${field}`" :value="`${joinMainLayerAttributes.table}.${field}`">{{ getAttributeOptionLabel(field) }}</a-select-option>
                                            </a-select-opt-group>
                                        </a-select>
                                    </a-col>

                                    <a-col :span="2" style="text-align: center; line-height: 32px; font-weight: bold;">=</a-col>

                                    <a-col :span="11">
                                        <a-select v-model:value="advFilterState.joinAttrSecondary" placeholder="Atributo Camada B" style="width: 100%">
                                            <a-select-opt-group v-if="joinSecondaryLayerAttributes" :key="joinSecondaryLayerAttributes.name">
                                                <template #label>
                                                    <span>{{ joinSecondaryLayerAttributes.name }}</span>
                                                </template>
                                                <a-select-option v-for="field in joinSecondaryLayerAttributes.fields" :key="`${joinSecondaryLayerAttributes.table}.${field}`" :value="`${joinSecondaryLayerAttributes.table}.${field}`">{{ getAttributeOptionLabel(field) }}</a-select-option>
                                            </a-select-opt-group>
                                        </a-select>
                                    </a-col>
                                </a-row>
                            </a-form-item>
                        </div>
                    </a-form>
                </a-tab-pane>

                <a-tab-pane key="2" tab="2. Filtros Lógicos">
                    <div style="max-height: 300px; overflow-y: auto; padding-right: 5px;">
                        <div v-for="(rule, index) in advFilterState.rules" :key="rule.id" class="my-2 p-2 rounded-1" style="background-color: #f0f2f5; border-left: 4px solid #1890ff;">
                            <a-row :gutter="4">
                                <a-col :span="4">
                                    <a-select v-model:value="rule.logic" style="width: 100%" :disabled="index === 0">
                                        <a-select-option value="AND">E (AND)</a-select-option>
                                        <a-select-option value="OR">OU (OR)</a-select-option>
                                    </a-select>
                                </a-col>

                                <a-col :span="7">
                                    <a-select v-model:value="rule.attribute" style="width: 100%" placeholder="Atributo">
                                        <a-select-opt-group v-for="layer in availableAttributes">
                                            <template #label>
                                                <span>{{ layer.name }}</span>
                                            </template>
                                            <a-select-option v-for="field in layer.fields" :key="`${layer.table}.${field}`" :value="`${layer.table}.${field}`">{{ getAttributeOptionLabel(field) }}</a-select-option>
                                        </a-select-opt-group>
                                    </a-select>
                                </a-col>

                                <a-col :span="5">
                                    <a-select v-model:value="rule.operator" style="width: 100%">
                                        <a-select-option value="==">== (Igual)</a-select-option>
                                        <a-select-option value="!=">!= (Diferente)</a-select-option>
                                        <a-select-option value=">">> (Maior)</a-select-option>
                                        <a-select-option value="<">< (Menor)</a-select-option>
                                        <a-select-option value="contains">Contém</a-select-option>
                                    </a-select>
                                </a-col>

                                <a-col :span="6">
                                    <a-auto-complete v-model:value="rule.value" :options="getSuggestions(`rule-${rule.id}`)" placeholder="Valor..." style="width: 100%" :filter-option="false" />
                                </a-col>

                                <a-col :span="2" style="text-align: right;">
                                    <a-button @click="removeRule(index, 'rules')" danger><i class="fa fa-times" /></a-button>
                                </a-col>
                            </a-row>
                        </div>
                    </div>
                    <a-button @click="addRule('rules')" type="dashed" block style="margin-top: 10px;"><i class="fa fa-plus"></i> Adicionar Condição de Filtro</a-button>
                </a-tab-pane>

                <a-tab-pane key="3" tab="3. Estilos e Cores (Condicional)">
                    <div style="max-height: 250px; overflow-y: auto;">
                        <div v-for="(style, index) in advFilterState.styles" :key="style.id" class="my-2 p-2 rounded-1" style="background-color: #fffbe6; border: 1px solid #ffe58f;">
                            <div v-if="!style.isDefault" style="margin-bottom: 8px;">
                                <strong>SE:</strong>
                                <a-space>
                                    <a-select v-model:value="style.attribute" style="width: 120px" placeholder="Atributo">
                                        <a-select-opt-group v-for="layer in availableAttributes">
                                            <template #label>
                                                <span>{{ layer.name }}</span>
                                            </template>
                                            <a-select-option v-for="field in layer.fields" :value="`${layer.table}.${field}`">{{ getAttributeOptionLabel(field) }}</a-select-option>
                                        </a-select-opt-group>
                                    </a-select>

                                    <a-select v-model:value="style.operator" style="width: 80px">
                                        <a-select-option value="==">==</a-select-option>
                                        <a-select-option value=">">></a-select-option>
                                        <a-select-option value="<"><</a-select-option>
                                        <a-select-option value="contains">Contém</a-select-option>
                                    </a-select>

                                    <a-auto-complete v-model:value="style.value" :options="getSuggestions(`style-${style.id}`)" placeholder="Valor..." style="width: 120px" :filter-option="false" />

                                    <a-button @click="removeRule(index, 'styles')" size="small" danger type="text"><i class="fa fa-trash" /></a-button>
                                </a-space>
                            </div>
                            <div v-else style="margin-bottom: 8px;"><strong>ESTILO PADRÃO (Aplicado aos demais registros):</strong></div>
                            <a-row :gutter="8">
                                <a-col :span="2">
                                    <label style="font-size: 11px;">Icone:</label> <br />
                                    <a-switch v-model:checked="style.icon" />
                                </a-col>
                                <a-col :span="8" v-if="style.icon">
                                    <label style="font-size: 11px;">Imagem:</label> <br />
                                    <a-button size="small" @click="openImagePicker(style)" :icon="h(PictureOutlined)" class="me-2">Selecionar</a-button>
                                    <a-button size="small" @click="() => style.iconPath = null" :icon="h(DeleteOutlined)" v-if="style.iconPath" type="primary" danger title="Remover icone" />
                                </a-col>
                            </a-row>
                            <a-row :gutter="8">
                                <a-col :span="8">
                                    <label style="font-size: 11px;">Cor (Fundo):</label>
                                    <input type="color" v-model="style.fill" style="width: 100%; height: 25px; border:none; padding:0;" />
                                </a-col>
                                <a-col :span="8">
                                    <label style="font-size: 11px;">Cor (Borda):</label>
                                    <input type="color" v-model="style.stroke" style="width: 100%; height: 25px; border:none; padding:0;" />
                                </a-col>
                                <a-col :span="8">
                                    <label style="font-size: 11px;">Atributo no Rótulo:</label>
                                    <a-select v-model:value="style.labelField" style="width: 100%" size="small">
                                        <a-select-option value="NONE">-- Sem Texto --</a-select-option>
                                        <a-select-opt-group v-for="layer in availableAttributes">
                                            <template #label>
                                                <span>{{ layer.name }}</span>
                                            </template>
                                            <a-select-option v-for="field in layer.fields" :key="`${layer.table}.${field}`" :value="`${layer.table}.${field}`">{{ getAttributeOptionLabel(field) }}</a-select-option>
                                        </a-select-opt-group>
                                    </a-select>
                                </a-col>
                            </a-row>
                        </div>
                    </div>
                    <a-button @click="addRule('styles')" type="dashed" block style="margin-top: 10px; border-color: #faad14; color: #faad14;"><i class="fa fa-plus"></i> Adicionar Regra de Cor/Borda</a-button>

                    <div id="exampleMap" class="exampleMap"></div>
                </a-tab-pane>
            </a-tabs>
            <div style="margin-top: 20px; border-top: 1px solid #eee; padding-top: 15px;">
                <a-row :gutter="16" align="middle">
                    <a-col :span="14">
                        <label style="font-weight: bold;">Nome da Nova Camada Resultante:</label>
                        <a-input v-model:value="advFilterState.outputLayerName" @input="validateName" />
                    </a-col>

                    <a-col :span="10" style="text-align: right; margin-top: 22px;">
                        <a-button @click="showAdvFilterDialog = false" style="margin-right: 10px;">Cancelar</a-button>
                        <a-button @click="applyAdvancedFilter" :loading="loadingFilters" type="primary" class="btn-success"><i class="fa fa-play" /> Executar Análise</a-button>
                    </a-col>
                </a-row>
            </div>
        </div>
    </a-modal>

    <a-modal
        v-model:open="showImagePicker"
        title="Imagens Gerais"
        :footer="null"
        @cancel="closeImagePicker"
        destroyOnClose
    >
        <ClientImagesPicker
            :selected-image-path="activeImagePickerStyle?.iconPath"
            @save="handleImageSave"
            @cancel="closeImagePicker"
        />
    </a-modal>
</template>

<script setup>
import {computed, nextTick, onMounted, ref, shallowRef, watch, h} from "vue";
import {openNotification} from "../../../../utils/utilities";
import GeoJSON from "ol/format/GeoJSON";
import {geoJsonReadOptions} from "../../../../open-layers/projections";
import {
    addLayerToMap,
    createDefaultBaseStyle,
    generateLayerStyle,
    getAttributeOptionLabel,
    registerLayerInCurrentModule,
    registerLayerStateListeners
} from "../../../../open-layers/helpers";
import OLMap from "ol/Map";
import {baseLayers} from "../../../../open-layers/baseLayers";
import View from "ol/View";
import {defaults as defaultControlsOL} from "ol/control/defaults";
import {defaults as defaultInteractionsOL} from "ol/interaction/defaults";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import Feature from "ol/Feature";
import Style from "ol/style/Style";
import Point from "ol/geom/Point";
import Polygon from "ol/geom/Polygon";
import ClientImagesPicker from "../../Components/ClientImagesPicker.vue";
import {DeleteOutlined, PictureOutlined} from "@ant-design/icons-vue";
import {getCenter} from "ol/extent";
import Photo from "ol-ext/style/Photo";
import Stroke from "ol/style/Stroke";
import CircleStyle from "ol/style/Circle";
import Fill from "ol/style/Fill";
import TextStyle from 'ol/style/Text';

const props = defineProps(['mapLayers', 'moduleSelected', 'layerRegistrationContext']);
const advFilterState = ref({ mode: 'single', targetLayer: null, joinMainLayer: null, joinSecondaryLayer: null, joinType: 'inner', joinMethod: 'spatial', joinAttrMain: null, joinAttrSecondary: null, rules: [], styles: [{ id: Date.now(), isDefault: true, attribute: null, operator: '==', value: '', fill: '#ffcc33', stroke: '#cc9900', labelField: 'NONE', icon: false, iconPath: '' }], outputLayerName: 'Resultado Filtro' });
const advFilterTab = ref('1');
const availableSuggestions = ref({});
const loadingFilters = ref(false);
const showAdvFilterDialog = ref(false);
const showImagePicker = ref(false);
const activeImagePickerStyleId = ref(null);
const exampleMapRef = shallowRef(null);
const examplePreviewLayerRef = shallowRef(null);
const examplePreviewSourceRef = shallowRef(null);
const mapLayersFilterOptions = ref([]);
const availableAttributes = ref([]);
const joinMainLayerAttributes = computed(() => availableAttributes.value.find((layer) => layer.name === advFilterState.value.joinMainLayer) || null);
const joinSecondaryLayerAttributes = computed(() => availableAttributes.value.find((layer) => layer.name === advFilterState.value.joinSecondaryLayer) || null);
const layersToCheck = computed(() => {
    if (advFilterState.value.mode === 'single') {
        return advFilterState.value.targetLayer
            ? [advFilterState.value.targetLayer]
            : [];
    }

    if (advFilterState.value.mode === 'join') {
        return [
            advFilterState.value.joinMainLayer,
            advFilterState.value.joinSecondaryLayer
        ].filter(Boolean);
    }

    return [];
});
const selectedSuggestionEntries = computed(() => {
    return [
        ...advFilterState.value.rules.map(rule => ({
            key: `rule-${rule.id}`,
            attribute: rule.attribute,
            search: rule.value || '',
        })),
        ...advFilterState.value.styles.map(style => ({
            key: `style-${style.id}`,
            attribute: style.attribute,
            search: style.value || '',
        })),
    ].filter(entry => entry.attribute);
});

const activeImagePickerStyle = computed(() => {
    return advFilterState.value.styles.find(style => style.id === activeImagePickerStyleId.value) || null;
});

const openImagePicker = (style) => {
    activeImagePickerStyleId.value = style?.id ?? null;
    showImagePicker.value = true;
};

const closeImagePicker = () => {
    showImagePicker.value = false;
    activeImagePickerStyleId.value = null;
};

const handleImageSave = (payload) => {
    if (activeImagePickerStyle.value) activeImagePickerStyle.value.iconPath = payload.path;
    closeImagePicker();

    if (advFilterTab.value === '3') {
        nextTick(() => {
            updateExamplePreviewMap();
            window.requestAnimationFrame(() => {
                if (!exampleMapRef.value) return;
                exampleMapRef.value.updateSize();
                updateExamplePreviewMap();
            });
        });
    }
}

const openAdvancedFilter = () => {
    advFilterState.value.rules = [];
    advFilterState.value.targetLayer = null;
    advFilterState.value.joinMainLayer = null;
    advFilterState.value.joinSecondaryLayer = null;
    showAdvFilterDialog.value = true;
};

const addRule = (type) => {
    if (type === 'rules') advFilterState.value.rules.push({ id: Date.now(), logic: 'AND', attribute: null, operator: '==', value: '' });
    else advFilterState.value.styles.push({ id: Date.now(), isDefault: false, attribute: null, operator: '==', value: '', fill: '#ffff00', stroke: '#000000', labelField: 'NONE', icon: false, iconPath: '' });
};

const removeRule = (index, type) => {
    if (type === 'rules') advFilterState.value.rules.splice(index, 1);
    else advFilterState.value.styles.splice(index, 1);
};

const getSuggestions = (key) => {
    if (!key) return [];

    return availableSuggestions.value[key] || [];
};

const validateName = () => {
    const layerNames = (props.mapLayers || []).map(layer => layer.get('name').toLowerCase())
    const layerName = advFilterState.value.outputLayerName.toLowerCase()

    if (layerName === '') {
        openNotification('error', 'Digite um nome para a camada resultante');
        return false;
    } else if (layerNames.includes(layerName)) {
        openNotification('error', 'Já existe uma camada com esse nome');
        return false;
    }

    return true;
};

const expandQualifiedPropertiesInGeoJson = (geojson) => {
    if (!geojson || !Array.isArray(geojson.features)) return geojson;

    geojson.features.forEach((feature) => {
        const properties = feature?.properties;
        if (!properties || typeof properties !== 'object') return;

        Object.entries(properties).forEach(([key, value]) => {
            const fallbackKey = getAttributeOptionLabel(key);

            if (fallbackKey && !(fallbackKey in properties)) {
                properties[fallbackKey] = value;
            }
        });
    });

    return geojson;
};

const evaluateCondition = (fAttr, operator, value) => {
    if (fAttr === null || fAttr === undefined) return false;

    let typedValue = value.trim();
    const isNumericComparisonCandidate = typedValue !== '' && !isNaN(typedValue) && !isNaN(fAttr);

    if (isNumericComparisonCandidate) {
        typedValue = Number(typedValue);
        fAttr = Number(fAttr);
    }

    switch(operator) {
        case '==': return fAttr === typedValue;
        case '!=': return fAttr !== typedValue;
        case '>': return fAttr > typedValue;
        case '<': return fAttr < typedValue;
        case '>=': return fAttr >= typedValue;
        case '<=': return fAttr <= typedValue;
        case 'contains': return String(fAttr).toLowerCase().includes(String(typedValue).toLowerCase());
        default: return false;
    }
};

const getFeatureAttributeValue = (feature, attribute) => {
    if (!feature || !attribute) return undefined;

    const directValue = feature.get(attribute);
    if (directValue !== undefined) return directValue;

    const fallbackKey = getAttributeOptionLabel(attribute);
    if (!fallbackKey || fallbackKey === attribute) return undefined;

    return feature.get(fallbackKey);
};

const buildPreviewIconSrc = (iconPath, styleId) => {
    if (!iconPath) return '';
    const separator = iconPath.includes('?') ? '&' : '?';
    return `${iconPath}${separator}previewStyleId=${styleId}`;
};

const refreshPreviewAfterIconLoad = (feature, src) => {
    if (!src) return;

    const image = new Image();
    image.onload = () => {
        feature.changed();
        examplePreviewLayerRef.value?.changed();
        exampleMapRef.value?.render();
    };
    image.src = src;
};

const buildPreviewLotFeature = (style, index, total) => {
    const lotWidth = 30;
    const lotHeight = 50;
    const gap = 10;
    const totalWidth = total * lotWidth + Math.max(0, total - 1) * gap;
    const startX = -totalWidth / 2;
    const minX = startX + (index * (lotWidth + gap));
    const maxX = minX + lotWidth;
    const minY = -lotHeight / 2;
    const maxY = lotHeight / 2;

    let geometry = new Polygon([[
        [minX, minY],
        [maxX, minY],
        [maxX, maxY],
        [minX, maxY],
        [minX, minY],
    ]]);

    if (style.icon) geometry = new Point(getCenter(geometry.getExtent()));

    const feature = new Feature({ geometry });

    const attributeKey = style.attribute || 'preview_attribute';
    const labelField = style.labelField || 'NONE';
    const exampleLabel = labelField === 'NONE' ? null : getAttributeOptionLabel(labelField);

    feature.set('color', style.fill || '#ffcc33');
    feature.set('strokeColor', style.stroke || '#cc9900');
    feature.set('customLabelField', labelField);
    feature.set(attributeKey, style.value || `Valor ${index + 1}`);

    if (style.icon && !style.iconPath) {
        feature.setStyle(new Style({
            image: new CircleStyle({
                radius: 15,
                fill: new Fill({
                    color: style.fill || '#ffcc33'
                }),
                stroke: new Stroke({
                    color: style.stroke || '#cc9900',
                    width: 2,
                }),
            }),

            text: new TextStyle({
                text: !!exampleLabel ? getAttributeOptionLabel(feature.get('customLabelField')) : '',
                offsetY: 25,

                fill: new Fill({
                    color: '#000'
                }),

                stroke: new Stroke({
                    color: '#fff',
                    width: 3
                })
            })
        }));
    } else if (style.icon && style.iconPath) {
        const previewIconSrc = buildPreviewIconSrc(style.iconPath, style.id);
        feature.setStyle(new Style({
            image: new Photo({
                src: previewIconSrc,
                radius: 18,
                crop: true,
                kind: 'anchored',
                shadow: 2,
                stroke: new Stroke({
                    color: style.stroke || '#cc9900',
                    width: 2,
                }),
            }),

            text: new TextStyle({
                text: !!exampleLabel ? getAttributeOptionLabel(feature.get('customLabelField')) : '',
                offsetY: 25,

                fill: new Fill({
                    color: '#000'
                }),

                stroke: new Stroke({
                    color: '#fff',
                    width: 3
                })
            })
        }));
        refreshPreviewAfterIconLoad(feature, previewIconSrc);
    } else {
        feature.setStyle(undefined);
    }

    if (exampleLabel) {
        feature.set(labelField, exampleLabel);
    }

    return feature;
};

const updateExamplePreviewMap = () => {
    const previewLayer = ensureExamplePreviewLayer();
    const previewSource = examplePreviewSourceRef.value;
    const previewMap = exampleMapRef.value;
    const styles = advFilterState.value.styles || [];

    previewLayer.setStyle(generateLayerStyle(
        createDefaultBaseStyle('#cc9900', '#ffcc33'),
        'NONE'
    ));

    if (!previewSource) return;

    const features = styles.map((style, index) => buildPreviewLotFeature(style, index, styles.length));
    previewSource.clear();
    previewSource.addFeatures(features);

    const extent = previewSource.getExtent();
    if (previewMap && extent.every(Number.isFinite)) {
        previewMap.getView().fit(extent, {
            padding: [20, 20, 20, 20],
            maxZoom: 20,
            minZoom: 10,
            duration: 0,
        });
        previewMap.render();
    }
};

const ensureExamplePreviewLayer = () => {
    if (examplePreviewLayerRef.value) return examplePreviewLayerRef.value;

    const source = new VectorSource();
    const layer = new VectorLayer({
        source,
        style: generateLayerStyle(createDefaultBaseStyle('#cc9900', '#ffcc33'), 'NONE'),
    });

    examplePreviewSourceRef.value = source;
    examplePreviewLayerRef.value = layer;

    return layer;
};

const buildFeaturePointGeometry = (geometry) => {
    if (!geometry) return null;
    const geometryType = geometry.getType?.();

    if (geometryType === 'Point') return geometry;
    if (geometryType === 'Polygon' && typeof geometry.getInteriorPoint === 'function') {
        return geometry.getInteriorPoint();
    }
    if (geometryType === 'MultiPolygon' && typeof geometry.getInteriorPoints === 'function') {
        const coordinates = geometry.getInteriorPoints()?.getCoordinates?.() || [];
        if (coordinates.length > 0) return new Point(coordinates[0]);
    }
    if (geometryType === 'LineString' && typeof geometry.getCoordinateAt === 'function') {
        return new Point(geometry.getCoordinateAt(0.5));
    }

    const extent = geometry.getExtent?.();
    if (!extent || !extent.every(Number.isFinite)) return null;

    return new Point(getCenter(extent));
};

const applyAdvancedFilter = async () => {
    const state = advFilterState.value;

    if (!validateName()) return;
    if (state.mode === 'single' && !state.targetLayer) return openNotification('error', 'Selecione uma camada válida.');
    if (state.mode === 'join' && (!state.joinMainLayer || !state.joinSecondaryLayer)) return openNotification('error', 'Selecione as duas camadas.');

    loadingFilters.value = true;
    const endpoint = state.mode === 'single' ? '/api/maps/advanced-filter/single' : '/api/maps/advanced-filter/join';

    const { data } = await window.axios.post(endpoint, state);
    const normalizedGeoJson = expandQualifiedPropertiesInGeoJson(data);
    const resultFeatures = new GeoJSON().readFeatures(normalizedGeoJson, geoJsonReadOptions());

    if (resultFeatures.length === 0) {
        loadingFilters.value = false;

        return openNotification('warning', state.mode === 'join'
            ? 'O Join resultou em zero geometrias.'
            : 'Nenhum item atende aos filtros informados.');
    }

    const defaultStyle = state.styles.find(s => s.isDefault);
    resultFeatures.forEach(f => {
        f.unset('color');
        f.unset('strokeColor');
        f.unset('customLabelField');
        f.unset('useIcon');
        f.unset('iconPath');

        let appliedStyle = state.styles.find(s => {
            if (s.isDefault) return false;
            return evaluateCondition(getFeatureAttributeValue(f, s.attribute), s.operator, s.value);
        });

        if (!appliedStyle) appliedStyle = defaultStyle;

        if (appliedStyle) {
            f.set('color', appliedStyle.fill);
            f.set('strokeColor', appliedStyle.stroke);
            f.set('customLabelField', appliedStyle.labelField);

            if (appliedStyle.icon) {
                const pointGeometry = buildFeaturePointGeometry(f.getGeometry());
                if (pointGeometry) f.setGeometry(pointGeometry);
                f.set('useIcon', !!appliedStyle.iconPath);
                f.set('iconPath', appliedStyle.iconPath);
            }
        }
    });

    let baseLayer;

    if (state.mode === 'single') baseLayer = (props.mapLayers || []).find((layer) => layer.get('name') === state.targetLayer)
    else if (state.mode === 'join') baseLayer = (props.mapLayers || []).find((layer) => layer.get('name') === state.joinMainLayer)

    if (!baseLayer) {
        loadingFilters.value = false;
        return openNotification('error', 'Não foi possível localizar a camada base da consulta.');
    }

    const fixedFilters = Object.fromEntries(
        state.rules.map(rule => [
            rule.attribute.split('.').at(-1),
            [rule.value]
        ])
    );

    const newLayer = addLayerToMap(
        resultFeatures,
        state.outputLayerName,
        defaultStyle?.fill || '#ffcc33',
        defaultStyle?.stroke || '#cc9900',
        defaultStyle?.labelField || 'NONE',
        {font: baseLayer.get('font'), fixedFilters}
    );

    newLayer.set('geo_table', baseLayer.get('geo_table'))
    newLayer.set('geo_server_layer', baseLayer.get('geo_server_layer'))
    newLayer.set('displayInLayerSwitcher', true);
    newLayer.set('layerSwitcherGroup', props.moduleSelected || 'Padrão');
    newLayer.set('layer_type', 'VectorLayer');

    registerLayerStateListeners([newLayer], props.layerRegistrationContext?.refreshLayerList);
    registerLayerInCurrentModule(newLayer, props.layerRegistrationContext);

    openNotification('success', `Consulta Executada: ${resultFeatures.length} itens.`);
    showAdvFilterDialog.value = false;
    loadingFilters.value = false;
};

onMounted(() => {
    mapLayersFilterOptions.value = (props.mapLayers || []).map(l => ({value: l.get('name'), label: l.get('name')}));
});

watch(
    () => props.mapLayers,
    (layers) => mapLayersFilterOptions.value = (layers || []).map(l => ({value: l.get('name'), label: l.get('name')})),
    { immediate: true }
);

watch(advFilterTab, async (tab) => {
    if (tab !== '3') return;
    await nextTick();

    if (!exampleMapRef.value) {
        const previewLayer = ensureExamplePreviewLayer();
        exampleMapRef.value = new OLMap({
            target: 'exampleMap',
            layers: [baseLayers(), previewLayer],
            view: new View(),
            controls: defaultControlsOL({ rotate: false, zoom: false }),
            interactions: defaultInteractionsOL({
                altShiftDragRotate: false,
                doubleClickZoom: false,
                dragPan: false,
                keyboard: false,
                mouseWheelZoom: false,
                pinchRotate: false,
                pinchZoom: false,
                shiftDragZoom: false,
            }),
        });
    }

    exampleMapRef.value.setTarget('exampleMap');
    exampleMapRef.value.updateSize();
    updateExamplePreviewMap();

    window.requestAnimationFrame(() => {
        if (!exampleMapRef.value) return;
        exampleMapRef.value.updateSize();
        updateExamplePreviewMap();
    });
});

watch(
    () => advFilterState.value.styles,
    () => { updateExamplePreviewMap(); },
    { deep: true }
);

watch(layersToCheck,
    async (layers) => {
        if (!layers.length) {
            availableAttributes.value = [];
            return;
        }

        const { data } = (await window.axios.get('/api/maps/advanced-filter/attributes', {
            params: { layers }
        }));

        availableAttributes.value = data.data
    },  { immediate: true }
);


watch(() => ({
        layers: layersToCheck.value,
        entries: selectedSuggestionEntries.value,
    }),
    async ({ layers, entries }) => {
        if (!layers.length || !entries.length) {
            availableSuggestions.value = {};
            return;
        }

        const { data } = await window.axios.get('/api/maps/advanced-filter/suggestions', {
            params: { layers, entries: JSON.stringify(entries) }
        });

        availableSuggestions.value = data.data || {};
    }, { immediate: true, deep: true }
);
</script>

<style scoped>
.exampleMap { width: 100%; height: 300px; margin-top: 20px; }
</style>
